import {Component, Input, OnInit} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {NotificationsApiService} from "../../api/notifications-api.service";
import {
  NotificationAction,
  UserNotificationActionGroupDto,
  UserNotificationDto,
  UserNotificationOverviewDto
} from "../../types/user-notifications.types";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageHelper} from "../../../../core/helper/message-helper";
import {AppMessageService} from "../../../../core/service/app-message.service";
import {TICKET_STATUS_MAP, TicketStatus, TicketStatusMeta} from "../../../tickets/types/tickets.types";


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['notifications.component.scss']
})
export class NotificationsComponent extends CoreComponent implements OnInit {

  @Input() notifications?: UserNotificationDto[] | undefined;

  notificationOverview: UserNotificationOverviewDto | undefined;

  showNotifications?: UserNotificationDto[];

  groupedNotifications?: UserNotificationActionGroupDto[];

  newNotifications: number = 0;

  constructor(protected notificationApiService: NotificationsApiService,
              protected router: Router,
              protected messageService: AppMessageService,
              protected route: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {

    if (this.notifications) {
      // show provided notifications
      this.showNotifications = this.notifications;
      this.applyTicketStatusMetadata(this.showNotifications);
      this.groupedNotifications = this.groupByAction(this.showNotifications);
      this.initialized = true;

    } else {
      // retrieve notifications
      this.notificationApiService.getNotifications().subscribe(value => {
        this.notificationOverview = value;
        this.showNotifications = this.notificationOverview.notifications;
        this.applyTicketStatusMetadata(this.showNotifications);
        this.groupedNotifications = this.groupByAction(this.showNotifications);
        this.newNotifications = this.getNewNotificationsNumber(this.showNotifications);
        this.initialized = true;
      }, error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);

      });
    }

  }

  private applyTicketStatusMetadata(notifications: any[]): void {
    for (const notification of notifications) {
      const meta = this.getTicketStatusMeta(notification.ticketStatus);

      notification.ticketStatusLabel = meta?.label || '';
      notification.ticketStatusIcon = meta?.icon || '';
      notification.ticketStatusStyle = {
        color: meta?.color ? `var(--${meta.color})` : undefined,
        background: meta?.backgroundColor ? `var(--${meta.backgroundColor})` : undefined
      };
    }
  }

  groupByAction(notifications: UserNotificationDto[]): UserNotificationActionGroupDto[] {
    const groups: Record<number, UserNotificationDto[]> = {};

    for (const notification of notifications) {
      if (!groups[notification.action]) {
        groups[notification.action] = [];
      }
      groups[notification.action].push(notification);
    }

    const groupedArray: UserNotificationActionGroupDto[] = [];
    for (const action in groups) {
      groupedArray.push({action: +action as NotificationAction, notifications: groups[action]});
    }

    return groupedArray;
  }

  getNewNotificationsNumber(notifications: UserNotificationDto[]): number {
    let counter: number = 0;
    for (const notification of notifications) {
      if (notification.newNotification) {
        counter++;
      }
    }
    return counter;
  }

  navigateToTicket(notification: UserNotificationDto) {
    if (notification.action == NotificationAction.ticket) {
      const currentPath = this.getCurrentPathLastSegment();
      this.router.navigate([`/ds/ticket/${notification.id}/${currentPath}`]);
    }
  }

  getCurrentPathLastSegment(): string | undefined {
    const path = window.location.hash; // Gets the current path
    // Extracts the last segment
    return path.split('/').pop();
  }


  getTicketStatusMeta(status: string): TicketStatusMeta | undefined {
    return TICKET_STATUS_MAP[status as TicketStatus];
  }

}
